import { type RefObject, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useLocalStorage } from "@/lib/hooks/use-local-storage";
import { forceSearchFocusHash, usedPopularPhrasesCounterKey } from "@Constants/PortalConstants";

export default function useSearchHelper(
    openSearch: (value: boolean) => void,
    inputRef: RefObject<HTMLInputElement>,
) {
    const { hash, pathname, search } = useLocation();

    const { value: usedPopularPhrasesCounter, update } = useLocalStorage(usedPopularPhrasesCounterKey, 0);

    useEffect(() => {
        const onSearchEvent = (event: CustomEvent<string>) => {
            if (event.detail === "search") {
                openSearch(true);
                inputRef.current?.focus();
            }
        };
        openSearch(false);
        window.addEventListener("hashCustomEventChange", onSearchEvent);
        return () => window.removeEventListener("hashCustomEventChange", onSearchEvent);
    }, [inputRef, openSearch, pathname, search]);

    useEffect(() => {
        if (hash.includes(forceSearchFocusHash)) {
            if (pathname === "/") {
                if (usedPopularPhrasesCounter > 10) {
                    update(10);
                }
                openSearch(true);
            }

            const url = new URL(window.location.href);
            url.hash = "";
            window.history.replaceState(null, "", url);
        }
    }, [hash, openSearch, pathname, update, usedPopularPhrasesCounter]);
}
